"use strict";

const REGEXEN = {
  start_comment: /^<!--/,
  end_comment: /^-->/,
  start_code: /^```(\w*)/,
  end_code: /^```/,
  title: /^#([^#].*)/,
  step_title: /^##([^#].*)$/,
  section_title: /^###([^#].*)$/,
  special_section: /^###\s*(API Call|Demo|Sample Code)/,
}

const markdownSections = require('./markdown-sections');

const sectionsToMarkdown = (sections) => {
  if (!sections) return '';
  return sections.map(s => {
    let md = '';
    for (let i = 0; i < s.rank; ++i) md += '#';
    md += ' ' + s.title;
    md += '\n' + (s.text || '');
    if (s.sections) md += '\n' + sectionsToMarkdown(s.sections);
    return md;
  });
}

const extractRecipe = module.exports = md => {
  let sections = markdownSections(md);
  let recipe = extractJSONComment(sections[0].text, 'METADATA');
  if (sections[0].sections.length !== 1) throw new Error("Got more than one rank-1 heading");
  let recipeSection = sections[0].sections[0];
  recipe.title = recipeSection.title;
  recipe.description = recipeSection.text || '';
  recipe.steps = recipeSection.sections.map(extractStep);
  let finish = recipeSection.sections.pop();
  if (finish && finish.title === 'Finish') {
    recipe.steps.pop();
    recipe.finishText = finish.text + '\n' + sectionsToMarkdown(finish.sections);
  }
  return recipe;
}

const extractJSONComment = (md, type) => {
  const start_regex = new RegExp('^<!--' + type);
  let lines = md.split('\n');
  let data = null;
  for (let i = 0; i < lines.length; ++i) {
    if (lines[i].match(start_regex)) {
      data = '';
    } else if (data !== null && lines[i].match(REGEXEN.end_comment)) {
      break;
    } else if (data !== null) {
      data += lines[i] + '\n'
    }
  }
  return JSON.parse(data);
}

const extractStep = section => {
  let step = {
    title: section.title,
    description: section.text,
  };
  section.sections.forEach(subsection => {
    let codeDetails = extractCode(subsection.text);
    let language = codeDetails.language;
    let code = codeDetails.code;
    if (code) {
      if (subsection.title === 'API Call') {
        step.apiCall = JSON.parse(code);
        step.parameters = step.apiCall.parameters;
        delete step.apiCall.parameters;
        if (Object.keys(step.apiCall).length === 0) delete step.apiCall;
      } else if (subsection.title.startsWith('Sample Code')) {
        let titleMatch = subsection.title.match(/Sample Code\s+\((\w+)\)/);
        if (titleMatch && titleMatch[1]) language = titleMatch[1].toLowerCase();
        step.codeSnippet = step.codeSnippet || {};
        step.codeSnippet[language] = code;
      } else if (subsection.title === 'Demo') {
        step.demoHTML = code;
      }
    }
  })
  return step;
}

const extractCode = md => {
  let m = md.match(/```(\w+)?([\s\S]+)```/);
  if (m) return {language: m[1].trim(), code: m[2].trim()};
  else return {language:null, code:null};
}



// WEBPACK FOOTER //
// ./src/lib/markdown-to-recipe.js